import { TestCommonDialog } from './components/dialogs/test-common-dialog';
import { NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
// Angular Material
import { MaterialModule } from '../app/material.module';

@NgModule({
    imports: [
        MaterialModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
  ],
    declarations: [
        TestCommonDialog
    ],
    entryComponents: [
        TestCommonDialog
        ], 
    exports: [
        TestCommonDialog
    ]
})
  
export class TestCommonDialogModule {}